  <div class="declinePopup">
    <h2>Decline Request <img   src="../../../../assets/images/x.svg" (click)="modalRef.hide()" class="show-cursor" style="width: 30px;float: right;"/></h2>
    <br/>
    <span style="color:#53565A">Reason  <span style="color:red">*</span></span><br/>
    <span style="color:#53565A;">Character Limit {{this.count}}/500</span>
    <br/>
    <textarea style="border:1px solid #D0D0CE;width:100%;height:150px;margin-top:15px;" id="reason" [(ngModel)]="reason" maxlength="500" (ngModelChange)="showcount(reason)"></textarea>
    <div class="d-flex justify-content-end" style="margin-top:15px;margin-right: -10px">
        <button (click)="modalRef.hide()" class="button" type="button" style="background-color: #53565A;color:#fff">
            Cancel
        </button>
        <button [disabled]="this.flag" (click)="onReject()" class="button" type="button blue" style="background: #007CB0;color:#fff">Submit</button>
    </div>
</div>